export default __webpack_public_path__ + "a20847d8306889b5d50775b8f27bcdd0.svg";